// extracted by mini-css-extract-plugin
export default {"chart":"LyUJ_","customTooltip":"snlzh","chartLables":"lZ6br","item":"oL15K","active":"UipkZ","itemSquare":"YsGAv","itemText":"IqZ5F","itemPercent":"khbsG"};